import { OnDestroy } from '@angular/core';
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalizeRouterService } from 'localize-router';
import { fromEvent } from 'rxjs';
import { AuthService } from '../../_services/auth.sevice';
import { CarrelloService } from '../../_services/carrello.service';
import { HeaderService } from '../../_services/header.service';
import { StorageService } from '../../_services/storage.service';
var MenuComponent = /** @class */ (function () {
    function MenuComponent(storage, header, auth, router, carrelloService, localize) {
        this.storage = storage;
        this.header = header;
        this.auth = auth;
        this.router = router;
        this.carrelloService = carrelloService;
        this.localize = localize;
        this.subs = [];
        this.menu = [];
        this.menuSecondario = [];
        this.scrolled = false;
        this.showMobileMenu = false;
        this.totaleCarrello = 0;
        this.termineRicerca = '';
        this.showHeaderSecondario = false;
    }
    MenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.aggiornaTotaleCarrello();
        this.subs = [
            fromEvent(window, 'scroll').subscribe(function () { return _this.onScroll(); }),
            this.header.aggiornaCarrello.subscribe(function () { return _this.aggiornaTotaleCarrello(); }),
            this.header.setHeaderSecondario.subscribe(function (headerSecondario) { return _this.showHeaderSecondario = headerSecondario; })
        ];
        this.storage.getMapponeInLingua().subscribe(function (mappone) {
            _this.menu = mappone.menuHeader;
            _this.menuSecondario = mappone.menuHeaderSecondario;
            // this.menu[0].figli[1].figli = [JSON.parse(JSON.stringify(this.menu[1].figli[0]))];
        });
    };
    MenuComponent.prototype.ngOnDestroy = function () {
    };
    MenuComponent.prototype.onScroll = function () {
        this.scrolled = window.scrollY > 60;
    };
    MenuComponent.prototype.aggiornaTotaleCarrello = function () {
        var _this = this;
        this.totaleCarrello = 0;
        this.carrelloService.getProdotti().subscribe(function (prodotti) { return prodotti.forEach(function (p) { return _this.totaleCarrello += p.quantita; }); });
    };
    MenuComponent.prototype.logout = function () {
        var _this = this;
        this.auth.logout().subscribe(function () { return _this.router.navigate([_this.localize.translateRoute('/').toString()]); });
    };
    MenuComponent.prototype.accedi = function () {
        var _this = this;
        this.router.navigate([this.localize.translateRoute('/login').toString()], { queryParams: { returnUrl: window.location.href } }).then(function () { return _this.showMobileMenu = false; });
    };
    Object.defineProperty(MenuComponent.prototype, "logged", {
        get: function () {
            return this.auth.isLogged;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuComponent.prototype, "user", {
        get: function () {
            return this.auth.user;
        },
        enumerable: true,
        configurable: true
    });
    MenuComponent.prototype.cerca = function () {
        var _this = this;
        if (this.termineRicerca) {
            this.router.navigate([this.localize.translateRoute('/ricerca-generica')], { queryParams: { q: this.termineRicerca } }).then(function () { return _this.showMobileMenu = false; });
        }
    };
    MenuComponent.prototype.voceFiglioClicked = function (voce, voceFiglio) {
        var wasOpen = voceFiglio.open;
        voce.figli.forEach(function (v) { return v.open = false; });
        if (!wasOpen) {
            voceFiglio.open = true;
        }
    };
    return MenuComponent;
}());
export { MenuComponent };
